import { type FC } from 'react';
import { AppProviders } from './providers';
import { App as AppComponent } from './components/App';

const App: FC = () => {
  return (
    <AppProviders>
      <AppComponent />
    </AppProviders>
  );
};

export default App;
